import { color, font, query, space } from '@design/templateFns';
import { ThemeSpacingName } from '@design/theme';
import { ThemeFontName } from '@design/types';
import styled from 'styled-components';

export const Header = styled.header`
  display: grid;
  grid-gap: 12px;
  grid-auto-flow: column;
  justify-content: flex-end;
  align-items: center;
  height: 54px;
  margin: auto;
  width: calc(100% - ${space('x12')} - ${space('x12')});
  max-width: 1272px;
  background-color: white;
  position: relative;
  z-index: 101;
  .hideOnDesktop {
    display: none;
  }
  @media screen and (${query.below('desktop')}) {
    width: unset;
    height: unset;
  }
  @media screen and (${query.below('tablet')}) {
    width: unset;
    height: unset;
  }
  @media (max-width: 900px) {
    .hideOnMobile {
      display: none;
    }
    .hideOnDesktop {
      display: inherit;
    }
  }
`;
export const NavBorder = styled.div`
  border-bottom: 1px solid ${color('gray2')};
  width: 100%;

  @media (max-width: 900px) {
    .hideOnMobile {
      border-bottom: none;
    }
    .hideOnDesktop {
      display: inherit;
    }
  }
`;

export const Column = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  position: relative;
  height: 100%;
  z-index: 25;
  color: #242323;
  a,
  > .icon {
    height: 100%;
    line-height: 1.1;
    text-decoration: none;
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    padding: 0 12px;
    color: #242323;
    transition: 0.25s;
    color: #404040;
  }
  a span {
    position: absolute;
    bottom: 24px;
    right: 0px;
    font-size: 20px;
    color: #242323;
  }
  a:hover {
    color: #242323;
  }
`;

export const Dropdown = styled.div`
  display: grid;
  position: relative;
  height: 100%;
  z-index: 10;
  &:hover .menu {
    display: grid;
  }
  .menu {
    background-color: white;
    display: none;
    position: absolute;
    top: 100%;
    left: 0px;
    width: 192px;
    box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 0px 0px 4px 4px;
    border-top: 1px solid ${color('gray2')};
  }
  .menu a:first-child {
    margin-top: 1px;
  }
  .menu a {
    height: 44px;
    background-color: white;
  }
  .menu a:hover {
    background-color: #f4f4f4;
  }
`;

export const Text = styled.p<{
  $font?: ThemeFontName;
  $m?: string;
  $p?: string;
  $color?: string;
  $mobileFont?: ThemeFontName;
}>`
  ${({ $font }) => ($font ? font($font) : font('body-md-light'))};
  ${({ $m }) => ($m ? `margin: ${$m};` : ``)}
  ${({ $p }) => ($p ? `padding: ${$p};` : ``)}
    ${({ $color }) => ($color ? `color: ${$color};` : ``)}
    @media screen and (${query.below('tablet')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
  }
`;

export const List = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
  $mobileP?: ThemeSpacingName;
  $bg?: string;
  $center?: boolean;
  $centerHorz?: boolean;
  $centerVert?: boolean;
}>`
  display: grid;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  background-color: ${({ $bg }) => ($bg ? $bg : 'transparent')};
  ${({ $center }) =>
    $center
      ? `
    justify-items: center;
    align-content: center;
  `
      : ``}
  ${({ $centerHorz }) =>
    $centerHorz
      ? `
    justify-content: center;
  `
      : ``}
    ${({ $centerVert }) =>
    $centerVert
      ? `
    align-content: center;
  `
      : ``}
    @media screen and (${query.below('tablet')}) {
    padding: ${({ $mobileP }) => ($mobileP ? space($mobileP) : ``)};
    grid-gap: 0;
  }
`;

export const ChevronStyles = styled.span`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 20px;
`;

export const SecondarySublinkDownArrow = styled.div`
  display: flex;
  padding: 9px 7px 5px 7px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;
